<template>
    <div class="json-attributes nested-card">
        <h4 class="mb-3">Attributes</h4>
        <v-layout
                row
                class="delete-wrapper"
                v-for="(attribute, index) in attributeFields"
        >
            <v-flex xs6>
                <label>Response Attribute</label>
                <v-text-field
                        outline
                        v-model="attribute.attribute"
                        :error="!attribute.attribute"
                        :error-messages="!attribute.attribute? 'Attribute is Required':'' "
                        hint="You can select one of the existing attributes or create a new one"
                >
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                <label>User Attribute</label>
                <v-text-field
                        outline
                        v-model="attribute.value"
                        :error="!attribute.value"
                        :error-messages="!attribute.value? 'User Attribute is Required':'' "
                        hint="Set any value or clear user attribute using «not set» option"
                >
                </v-text-field>
            </v-flex>
            <v-btn
                    @click="deleteAttributeField(index)"
                    fab small color=""
                    class="delete-button"
            ><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </v-layout>
        <v-btn
                large round flat block
                class="primary--text"
                @click="addAttributeField"
        >
            <v-icon>add_circle_outline</v-icon>
            Add Response
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "attributeFields",
        props: {
            attributeFields: {
                type: Array,
                default: ()=>{
                    return []
                }
            }
        },
        methods: {
            addAttributeField() {
                this.attributeFields.push({
                    attribute:'',
                    value:''
                })
            },
            deleteAttributeField(index) {
                this.attributeFields.splice(index, 1)
            }
        }
    }
</script>

<style scoped>

</style>